"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialMediaBlock = exports.SocialNetworks = void 0;
const react_1 = __importDefault(require("react"));
const styled = __importStar(require("./styled"));
const IconSwitcher_1 = require("./IconSwitcher");
var SocialNetworks;
(function (SocialNetworks) {
    SocialNetworks["YOUTUBE"] = "youtube";
    SocialNetworks["LINKEDIN"] = "linkedin";
    SocialNetworks["FACEBOOK"] = "facebook";
    SocialNetworks["INSTAGRAM"] = "instagram";
    SocialNetworks["TWITTER"] = "twitter";
})(SocialNetworks = exports.SocialNetworks || (exports.SocialNetworks = {}));
const SocialMediaBlock = ({ socialLinks, fill, copyrightInsideContainer }) => {
    return (react_1.default.createElement(styled.Container, { copyrightInsideContainer: copyrightInsideContainer }, socialLinks.map(el => {
        return (el === null || el === void 0 ? void 0 : el.link) && react_1.default.createElement(IconSwitcher_1.IconSwitcher, { key: el.platform, platform: el.platform, fill: fill, link: el.link });
    })));
};
exports.SocialMediaBlock = SocialMediaBlock;
exports.default = exports.SocialMediaBlock;
